import types from 'pages/RequestWarrantyRepair/actions/types.js';

const INITIAL_STATE = {
  requestValue: {},
  componentsList: undefined,
  totalComponentMoney: undefined,
  getComponentsLoading: false,
  couponsList: undefined,
  getCouponsLoading: false,
  slipList: undefined,
  getSlipLoading: false,
};

export default  function reducers (state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.SET_VALUE_REQUEST_ID_VALUE:
      return {
        ...state,
        requestValue: action.payload,
      };

    //get components
    case types.GET_COMPONENTS_REQUEST:
      return {
        ...state,
        getComponentsLoading: true,
      };
    case types.GET_COMPONENTS_SUCCESS: {
      return {
        ...state,
        componentsList: action.payload,
        totalComponentMoney: (action.payload || []).reduce((total, value) => {
          if (!value.is_internal) {
            total = total + value.price ?? 0;
          }
          return total
        }, 0),
        getComponentsLoading: false,
      };
    }
    case types.GET_COMPONENTS_FAILURE:
      return {
        ...state,
        getComponentsLoading: false,
      };

    //get coupon promotion
    case types.GET_COUPONS_REQUEST:
      return {
        ...state,
        getCouponsLoading: true,
      };
    case types.GET_COUPONS_SUCCESS: {
      return {
        ...state,
        couponsList: action.payload,
        getCouponsLoading: false,
      };
    }
    case types.GET_COUPONS_FAILURE:
      return {
        ...state,
        getCouponsLoading: false,
      };

    //get slip list
    case types.GET_SLIP_REQUEST:
      return {
        ...state,
        getSlipLoading: true,
      };
    case types.GET_SLIP_SUCCESS: {
      return {
        ...state,
        slipList: action.payload,
        getSlipLoading: false,
      };
    }
    case types.GET_SLIP_FAILURE:
      return {
        ...state,
        getSlipLoading: false,
      };

    default:
      return state;
  }
}
